import React, { Component } from "react";
import PropTypes from "prop-types";
import moment from "moment";
import { Button } from "react-bootstrap";
import AddCircleOutlineIcon from "mdi-react/AddCircleOutlineIcon";
import { put } from "../../../utils/DeApi";

import Loader from "../../Loader/Loader";
import ErrorHandler from "../../ErrorHandler/ErrorHandler";
import axios from "axios";

class CatalogueAddPgm extends Component {
  constructor(props) {
    super(props);
    this.subscribedPromises = [];
    this.state = {};
  }

  async addToCatalogue() {
    const { doc, filing, onFilingAdded, user } = this.props;
    this.setState({ error: null, isLoading: true });

    const formatedDate = moment.utc(filing.filedAtDate).format("YYYY-MM-DD");
    const payload = {
      filingId: filing.accessionNo /* *** filing accession *** */,
      formType: filing.formType /* *** filing type *** */,
      exhibit: doc[0].type /* *** folder type *** */,
      cik: filing.cik /* *** filing cik *** */,
      companyName: filing.companyName,
      documentId: doc[0]?.documentId /* *** folder id *** */,
      document_url: doc[0]?.documentUrl /* *** folder url *** */,
      user: user?.sub /* *** analyst email *** */,
      userEmail: user?.email,
      filedAt: filing.filedAtDate /* *** full date with timeStamp *** */,
      film_number: undefined,
      doc_capture_date: moment().format("MM/DD/YYYY"),
      sec_url: doc[0].documentUrl,
      filing_review_date: moment().format("MM/DD/YYYY"),
      // analyst_name_who_recorded: user,
    };
    /* *** adding doc type and filing type separately *** */

    try {
      // const addDoc_dealsense = await put(`/catalogues/${formatedDate}`, payload)
      //   .promise;

      // added loan intel api to sync the data transfer from deal sense to loan intel
      await axios.put(
        `${process.env.REACT_APP_LOANINTEL_BASE_URL}/pmg/training/ext/${formatedDate}`,
        payload
      ).then((response) => {
        this.setState({
          isAddedFromPmg: response.data?.data?.isAddedFromPmg,
        });
      }).catch((error) => {
        console.error("Error adding document to Loan Intel:", error);
      });

      this.setState({ error: null, isLoading: false }, () =>
        // onFilingAdded({ ...addDoc_dealsense.data, ...{ filing: filing } })
        onFilingAdded({ ...{ filing: filing } })
      );
    } catch (error) {
      !error.isCanceled && this.setState({ error: error, isLoading: false });
    }
  }

  render() {
    const { isLoading, error, isAddedFromPmg } = this.state;
    const { screen, show, isAddedFromPmg: isAddedFromPmgProp, fileCheckLoading } = this.props;    

    if (isLoading) return <Loader />;
    if (error) return <ErrorHandler error={error} />;
    if (screen === "selection") {
      return (
        // <Button className="btn-success-deal-style roundedEdges" size="sm" onClick={() => this.addToCatalogue()}>
        //   <span className="material-icons">Add</span>
        // </Button>
        <Button
          variant="null"
          size="sm"
          onClick={() => this.addToCatalogue()}
          className="p-1 color-deal-style"
        >
          <AddCircleOutlineIcon size={20}></AddCircleOutlineIcon>
        </Button>
      );
    }
    return show ? (
      <Button
        variant="null"
        className="btn-success-deal-style roundedEdges"
        size="sm"
        onClick={() => this.addToCatalogue()}
        disabled={fileCheckLoading || isAddedFromPmg || isAddedFromPmgProp}
      >
        Add document
      </Button>
    ) : (
      <></>
    );
  }
}

CatalogueAddPgm.propTypes = {
  doc: PropTypes.object.isRequired,
  filing: PropTypes.object.isRequired,
  onFilingAdded: PropTypes.func.isRequired,
};

export default CatalogueAddPgm;
